const validateRateCard = (rateMatrix, rateCardTypes) => {
  const errors = [];
  outerLoop: for (const doc of rateCardTypes?.docType || []) {
    for (const travelMode of rateCardTypes?.travelMode || []) {
      for (const shipping of rateCardTypes?.shippingType || []) {
        const innerTemp = rateMatrix?.[doc]?.[travelMode]?.[shipping];
        if (Array.isArray(innerTemp)) {
          for (const item of innerTemp) {
            const hasZero = Object.entries(item).some(
              ([key, value]) => key !== "minValue" && value == 0
            );
            if (hasZero) {
              errors.push({ doc, travelMode, shipping });
              break outerLoop; // Exit all loops immediately
            }
          }
        }
      }
    }
  }
  return errors;
};
export default validateRateCard;
